import { Box } from "@gemini/core";
import type { PropsWithChildren } from "react";
import { createShellLikeId } from "@aviv-unified-frontend/internal";

import { BRAND_CONFIGURATION } from "../../../configs/brands";

import { useLayout } from "./useLayout";

export const Layout = ({ children }: PropsWithChildren) => {
  const { headerFooterConfig, layoutMode } = useLayout();
  const { Header, Footer } = BRAND_CONFIGURATION.layout;

  return (
    <Box
      backgroundColor="color.background.default"
      minHeight="100vh"
      display="flex"
      flexDirection="column"
    >
      <Box
        as="div"
        id={createShellLikeId("layout__banner")}
        /**
         * This custom attribute is used by React Aria to identify
         * top layers in the application (like modals, banners, etc.).
         *
         * data-react-aria-top-layer="true"
         *
         * If a custom modal were to be activated again, it might be necessary to add this custom attribute.
         *
         * See https://github.com/adobe/react-spectrum/issues/8784#issuecomment-3415368636
         */
      />
      {layoutMode !== "hidden" && (
        <Header
          headerFooterConfig={headerFooterConfig}
          layoutMode={layoutMode}
        />
      )}
      {children}
      {layoutMode !== "hidden" && (
        <Footer
          headerFooterConfig={headerFooterConfig}
          layoutMode={layoutMode}
        />
      )}
    </Box>
  );
};
